var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from '@xstyled/styled-components';
var OverlayWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 1;\n  visibility: hidden;\n"], ["\n  position: absolute;\n  z-index: 1;\n  visibility: hidden;\n"])));
var OverlayComponent = function (_a) {
    var children = _a.children;
    var overlayRef = React.useRef(null);
    React.useEffect(function () {
        var _a;
        var Overlay = overlayRef.current;
        if (!Overlay)
            return;
        var FilterCell = Overlay === null || Overlay === void 0 ? void 0 : Overlay.closest('.cell');
        var GridWrapper = FilterCell === null || FilterCell === void 0 ? void 0 : FilterCell.closest('.gridWrapper');
        // position of left edge of filter cell
        var relativeLeftOffset = (FilterCell === null || FilterCell === void 0 ? void 0 : FilterCell.offsetLeft) - ((_a = FilterCell === null || FilterCell === void 0 ? void 0 : FilterCell.parentElement) === null || _a === void 0 ? void 0 : _a.offsetLeft); // parent element = row
        // space available to the right edge of visible part of grid
        var spaceTotal = (GridWrapper === null || GridWrapper === void 0 ? void 0 : GridWrapper.clientWidth) + (GridWrapper === null || GridWrapper === void 0 ? void 0 : GridWrapper.scrollLeft) - relativeLeftOffset;
        // difference between availible space and width
        var spaceLeft = spaceTotal - (Overlay === null || Overlay === void 0 ? void 0 : Overlay.clientWidth);
        // left position
        var left = spaceLeft > 0 ? FilterCell === null || FilterCell === void 0 ? void 0 : FilterCell.offsetLeft : (FilterCell === null || FilterCell === void 0 ? void 0 : FilterCell.offsetLeft) + spaceLeft;
        // top calculation
        var topOffset = (FilterCell === null || FilterCell === void 0 ? void 0 : FilterCell.offsetTop) + (FilterCell === null || FilterCell === void 0 ? void 0 : FilterCell.clientHeight);
        Overlay.style.left = "".concat(left, "px");
        Overlay.style.top = "".concat(topOffset, "px");
        Overlay.style.visibility = "initial";
    });
    return (_jsx(OverlayWrapper, { ref: overlayRef, className: "filterOverlay", children: children }));
};
export default OverlayComponent;
var templateObject_1;
